<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        패턴
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Pattern</a>
          </li>
      </ul>
    </div>
    <b-card v-if="show">
      <b-row>
        <b-col>
          패턴 목록
        </b-col>
      </b-row>
      <hr>

      <b-card v-show="so.adv">
        <b-row>
          <b-col>
            <b-form-group label="웹쉘 구분" label-for="code_category" v-b-tooltip.hover >
              <b-form-checkbox-group v-model="so.opt.category">
                <b-button size="sm" variant="primary" @click="so.opt.category=[]"> 초기화 </b-button>
                <b-form-checkbox :value="'-'">미분류</b-form-checkbox>
                <b-form-checkbox :value="'2'">웹쉘</b-form-checkbox>
                <b-form-checkbox :value="'3'">스팸메일</b-form-checkbox>
                <b-form-checkbox :value="'4'">파일매니저</b-form-checkbox>
                <b-form-checkbox :value="'5'">랜섬웨어</b-form-checkbox>
                <b-form-checkbox :value="'6'">악성파일</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="파일 확장자" label-for="code_ext" v-b-tooltip.hover>
              <b-form-checkbox-group v-model="so.opt.ext">
                <b-button size="sm" variant="primary" @click="so.opt.ext=[]"> 초기화 </b-button>
                <b-form-checkbox :value="'1'">미분류</b-form-checkbox>
                <b-form-checkbox :value="'2'">CGI 실행파일</b-form-checkbox>
                <b-form-checkbox :value="'3'">JSP/WAR</b-form-checkbox>
                <b-form-checkbox :value="'4'">NodeJS</b-form-checkbox>
                <b-form-checkbox :value="'5'">ASP/ASPX</b-form-checkbox>
                <b-form-checkbox :value="'6'">PHP</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="탐지 규칙" label-for="code_type" v-b-tooltip.hover>
              <b-form-checkbox-group v-model="so.opt.type">
                <b-button size="sm" variant="primary" @click="so.opt.type=[]"> 초기화 </b-button>
                <b-form-checkbox :value="'1'">정규식</b-form-checkbox>
                <b-form-checkbox :value="'2'">유사도</b-form-checkbox>
                <b-form-checkbox :value="'3'">파일해시</b-form-checkbox>
                <b-form-checkbox :value="'4'">URL</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Usage status">
              <b-form-radio-group id="radio-group-2" v-model="so.opt.is_alive" v-b-tooltip.hover title="Please enter the Usage Status you want to search for">
                <b-form-radio :value="true" @click="so.sv=`is_alive`">사용</b-form-radio>
                <b-form-radio :value="false" @click="so.sv=`is_alive`">미사용</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group label="Code" label-for="ph_code" v-b-tooltip.hover title="Please enter the code you want to search for">
              <b-form-input v-model="so.sv" @click="so.sk='code';"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            등록일
            <b-form>
              <date-picker v-model="so.opt.created_at_sd" style="width: 80%" :lang="custom.lang.ko" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
          <span>~</span>
          <b-col md="4">
            등록일
            <b-form>
              <date-picker v-model="so.opt.created_at_ed" style="width: 80%" :lang="custom.lang.ko" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button size="sm" variant="primary" @click="refresh" > 검색 </b-button>
          <b-button size="sm" variant="secondary" @click="reset"> 초기화 </b-button>
          <b-button size="sm" variant="default" @click="so.adv = false"> 취소 </b-button>
        </b-form-group>
      </b-card>

      <b-row>
        <b-col sm="6">
          <!-- <b-pagination size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" /> -->
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset"><i class="fa fa-remove"></i></b-btn>
              <b-input-group-text size="sm" variant="outline-secondary">Code</b-input-group-text>

            </b-input-group-prepend>
            <b-form-input v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary"  @click="so.adv = true"><i :class="'fa ' + (so.adv ? 'fa-search-minus' : 'fa-search-plus')"> 상세 검색</i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="결과가 없습니다." class="table-responsive table_add"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="category" slot-scope="row">{{codes.code_category[row.item.category]}}</template>
        <template slot="ext" slot-scope="row">{{codes.code_ext[row.item.ext]}}</template>
        <template slot="type" slot-scope="row">{{codes.code_type[row.item.type]}}</template>
        <template slot="code" slot-scope="row">
          <a href="javascript:void(0)" class="a_tag" @click="detail(row.item)">
            {{row.item.code | truncate(80) }}
          </a>
        </template>
        <template slot="source" slot-scope="row">{{row.item.source}}</template>
        <template slot="is_alive" slot-scope="row">
          <b-badge v-if="row.item.is_alive == true" variant="success">사용</b-badge>
          <b-badge v-else>미사용</b-badge>
        </template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">더 보기</b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col md="4"></b-col>
        <b-col md="4">
          <b-pagination size="sm"  align="center" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
        </b-col>
        <b-col md="4">
          <div class="pull-right">
            <b-button size="sm" variant="success" @click="$router.push({ name: 'wsfinder_pattern', params: { id : 'add' }})" class="btn-add"> 등록 </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <!-- <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view> -->
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
